<template>
<div>
    <div class="page-body">
        <div class="tbs">
            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
                <!-- 委员会名称 -->
                <el-form-item label="我的主页" prop="name">
                    <div v-if="isDisplay" class="qr" :ref="'imageWrapper_' + params.dto.id">
                        <div class="bg">
                            <img :src="qr1" />
                        </div>
                        <span class="qr-inner" @click="downloadImg(params.dto.id)">
                            <el-tooltip content="点击下载二维码" placement="top-start">
                                <!-- <vue-qr :ref="'Qrcode' + params.dto.id" :text="urlQrcode(params.dto)" :logoSrc="photo" :margin="10" :size="500" :width="100" /> -->
                                <vue-qr class="qr-span" :ref="'Qrcode' + params.dto.id" :text="urlQrcode(params.dto)" colorDark="#034A9E" :logoSrc="photo" :dotScale="0.6" :margin="0" :size="500" :width="100" />
                            </el-tooltip>
                        </span>
                    </div>
                    <span v-else>暂无二维码</span>
                </el-form-item>
                <el-form-item label="我的团队" prop="name">
                    <el-table :data="params.jingshiTeam1List" :header-cell-style="{background:'#F3F4F7',color:'#555'}" style="width: 80%" border>
                        <el-table-column prop="name" header-align="center" label="团队名称">
                        </el-table-column>
                        <el-table-column label="推广二维码" width="180" header-align="center" align="center">
                            <template slot-scope="scope">
                                <div v-if="isDisplay" class="qr" :ref="'imageWrapper_' + scope.row.id">
                                    <div class="bg">
                                        <img :src="qr1" />
                                    </div>
                                    <span class="qr-inner" @click="downloadImg(scope.row.id)">
                                        <el-tooltip content="点击下载二维码" placement="top-start">
                                            <vue-qr class="qr-span" :ref="'Qrcode' + scope.row.id" :text="urlQrcode(scope.row)" colorDark="#034A9E" :logoSrc="photo" :dotScale="0.6" :margin="0" :size="500" :width="100" />
                                        </el-tooltip>
                                    </span>
                                </div>
                                <!-- <span v-if="urlQrcode(scope.row)" @click="downloadImg(scope.row.id)" style="height:100px">
                                    <el-tooltip class="item" effect="dark" content="点击下载二维码" placement="top-start">
                                        <vue-qr :ref="'Qrcode' + scope.row.id" :text="urlQrcode(scope.row)" :margin="10" :size="500" :width="100" :logoSrc="photo" />
                                    </el-tooltip>
                                </span> -->
                            </template>
                        </el-table-column>

                    </el-table>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import {
    getUserLawyerTeam
} from '@/api/jingshi';
import {
    getViewKey,
} from '@/api/account';
import VueQr from 'vue-qr'
import qr1 from '@/assets/images/qr1.png'
import qr2 from '@/assets/images/qr2.png'
import qr3 from '@/assets/images/qr3.png'
import html2canvas from "html2canvas"
export default {
    components: {
        VueQr
    },
    data() {
        return {
            loading: false,
            qr1,
            qr2,
            qr3,
            qrBgImage:'',
            listData: [],
            isDisplay: false,
            totalElements: 0, //总条数
            viewDat: {},
            photo: '',
            params: {
                dto: {}, // 关键词
                jingshiTeam1List: []
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                0: '未知',
                1: '启用',
                2: '禁用',
            };
            return transMap[e];
        }
    },
    methods: {
        logoSrc(data) {
            this.viewDat.imagePreUrl
            console.log(this.viewDat.imagePreUrl + data.photo);
            return this.viewDat.imagePreUrl + '?id=' + data.photo + '&token=' + this.viewDat.token;
        },
        logoSrc2(data) {
            this.viewDat.imagePreUrl
            console.log(this.viewDat.imagePreUrl + data.photo);
            return this.viewDat.imagePreUrl + '?id=' + data.photo + '&token=' + this.viewDat.token;
        },
        urlQrcode(data) {
            var url = "";
            if (data.customLink || data.modelLink) {
                var domain = 'jingshcqlawyer.com';
                if (data.customLink) {
                    domain = data.customLink + '/';
                } else {
                    domain = domain + '/' + data.modelLink + '?id=' + data.id;
                }
                url = 'http://' + domain;
            }

            return url;
        },
        toImage(link_id, res) {
            html2canvas(this.$refs['imageWrapper_' + link_id]).then(canvas => {
                let dataURL = canvas.toDataURL("image/png");
                res(dataURL);
            });
        },
        downloadImg(link_id) {
            console.log(link_id);
            this.toImage(link_id, function (url) {
                // const iconUrl = this.$refs['Qrcode' + link_id].$el.src
                const a = document.createElement('a')
                const event = new MouseEvent('click')
                a.download = link_id
                a.href = url
                a.dispatchEvent(event)
            });

        },
        // 获取文章列表
        getData() {
            var vues = this;
            this.loading = true;
            getUserLawyerTeam({}).then(res => {
                console.log(res);
                if (res.dto.customLink || res.dto.modelLink) {
                    vues.isDisplay = true;
                }
                vues.photo = vues.viewDat.imagePreUrl + '?id=' + res.dto.photo + '&token=' + vues.viewDat.token;
                vues.params = res;
                vues.loading = false;
            })
        },

    },
    created: function () {

        //初始化文件信息
        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl: res.imagePreUrl,
                token: res.token
            };
            this.getData();
        })

    }
}
</script>

<style lang="scss">
.page-body {
    padding: 20px;
}

.page-body table {
    width: 100%;
}

// 头部样式
.page-body th {
    background-color: #efefef;
}

.tbs {

    .pagination {
        background: white;
        text-align: center;
        margin: 0 0px 0 0px;
    }
}

.item {
    margin: 4px;
}

.qr {

    width: 170px;
    height: 170px;
    position: relative;

    .bg {
        position: absolute;

        img {
            width: 170px;
        }
    }

    .qr-inner img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

// .el-input__suffix {
//   right: 0px;
//   transition: all 0.3s;
// }
</style>



// WEBPACK FOOTER //
// page.vue?5d5a8b0a